/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

/* Component starts */
const UnitDetails = (props) => {
  /* Props destructuring starts */
  const { data, property } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  const unitNumber = data?.unit_number;
  const unitType = data?.unit_type;
  const unitName = data?.unit_name;
  const propertyName = property?.property_name;
  const propertyCity = property?.city;
  const propertyState = property?.state;
  const propertyCountry = property?.country;
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="basic-details-component-wrapper section container_md">
      <h3 className="table-heading font_m">Unit Details</h3>

      <div className="detail-box">
        <div className="basic">
          {propertyName !== undefined && propertyName !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                Property <br />
                <span className="font_m fw_4">
                  {propertyName !== undefined ? propertyName : "-"}
                </span>
              </p>
            </div>
          )}

          {propertyCity !== undefined && propertyCity !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                City <br />
                <span className="font_m fw_4">
                  {propertyCity !== undefined ? propertyCity : "-"}
                </span>
              </p>
            </div>
          )}

          {propertyState !== undefined && propertyState !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                State <br />
                <span className="font_m fw_4">
                  {propertyState !== undefined ? propertyState : "-"}
                </span>
              </p>
            </div>
          )}

          {propertyCountry !== undefined && propertyCountry !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                Country <br />
                <span className="font_m fw_4">
                  {propertyCountry !== undefined ? propertyCountry : "-"}
                </span>
              </p>
            </div>
          )}

          {unitName !== undefined && unitName !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                Unit Name <br />
                <span className="font_m fw_4">
                  {unitName !== undefined ? unitName : "-"}
                </span>
              </p>
            </div>
          )}

          {unitNumber !== undefined && unitNumber !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                Unit Number <br />
                <span className="font_m fw_4">
                  {unitNumber !== undefined ? unitNumber : "-"}
                </span>
              </p>
            </div>
          )}

          {unitType !== undefined && unitType !== "" && (
            <div className="detail">
              <p className="font_s fw_3">
                Unit Type <br />
                <span className="font_m fw_4">
                  {unitType !== undefined ? unitType : "-"}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
/* Component ends */

export default UnitDetails;
